import {
    SET_ORIGIN,
    SET_DESTINATION,
    SET_EQUIPMENT_TYPE
} from '../../actions/marketInsights/laneSearchActions';
import { equipmentTypeOptions } from '../../../helpers/dataHelpers';

interface LaneSearch {
    origin: any;
    destination: any;
    equipmentType: any;
}

const laneSearchInitialState: LaneSearch = {
    origin: null,
    destination: null,
    equipmentType: equipmentTypeOptions[0]
};

const laneSearchReducer = (laneSearch: LaneSearch = laneSearchInitialState, action: any): LaneSearch => {
    switch (action.type) {
        case SET_ORIGIN: {
            return {
                ...laneSearch,
                origin: action.payload
            };
        }
        case SET_DESTINATION: {
            return {
                ...laneSearch,
                destination: action.payload
            };
        }
        case SET_EQUIPMENT_TYPE: {
            return {
                ...laneSearch,
                equipmentType: action.payload
            };
        }
        default:
            return laneSearch;
    }
};

export default laneSearchReducer;
